/* eslint-disable @typescript-eslint/no-explicit-any */
import { MultilevelOptionType } from "../SelectField/FormSelect/types";

export const getParentByValue = (
  options: any[],
  value: string,
  depth = 0,
  previousItem = null,
) => {
  for (const item of options) {
    if (item.value === undefined) continue;
    if (typeof item.value !== 'string') {
      item.value = item.value.toString();
    }
    if (item.value === value) {
      return { options, depth, previousItem };
    } else if (item.children !== undefined) {
      const parent: any = getParentByValue(
        item.children,
        value,
        depth + 1,
        item,
      );
      if (parent) {
        return parent;
      }
    }
  }
  return null;
};

export const isAllChildrenSelected = (
  option: MultilevelOptionType,
  selected: string[],
): boolean => {
  if (!option.children) return false;
  return option.children.every(
    child =>
      selected.includes(child.value) &&
      (child.children ? isAllChildrenSelected(child, selected) : true),
  );
};

export const isAnyChildrenSelected = (
  option: MultilevelOptionType,
  selected: string[],
): boolean => {
  if (!option.children) return false;
  return option?.children?.some(
    child =>
      selected?.includes(child.value) || isAnyChildrenSelected(child, selected),
  );
};

export const extractChildValues = (option: MultilevelOptionType) => {
  let values: string[] = [];
  let options: any[] = [];
  values.push(option.value);
  options.push(option);

  if (option.children) {
    option.children?.forEach(child => {
      const childOptions = extractChildValues(child);
      values = [...values, ...childOptions.values];
      options = [...options, ...childOptions.options];
    });
  }

  return { values: values, options: options };
};

export const inputLabelFormatter = (values: string[], options: MultilevelOptionType[], maxLength: number = 5) => {
  if (!values || values.length === 0) return '';
  
  const labels = values.map(value => {
    const option = getItemFromOptions(value, options);
    return option ? option.label : value;
  });

  if (labels.length <= maxLength) {
    return labels.join(', ');
  }
  const truncatedLabels = labels.slice(0, maxLength - 1);
  return truncatedLabels.join(', ') + '...';
};

export const getItemFromOptions = (
  item: string,
  options: MultilevelOptionType[],
) => {
  const queue = [...options];
  while (queue.length) {
    const currentOption = queue.shift();
    if (currentOption) {
      if (currentOption.value === item) {
        return currentOption;
      }
      if (currentOption.children) {
        queue.push(...currentOption.children);
      }
    }
  }
  return null;
};
